import { render, staticRenderFns } from "./DashboardLivePayMessages.vue?vue&type=template&id=187e707e&scoped=true"
import script from "./DashboardLivePayMessages.vue?vue&type=script&lang=ts"
export * from "./DashboardLivePayMessages.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187e707e",
  null
  
)

export default component.exports